import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import session from './sessionReducer'
import cart from './cartReducer'
import bag from './bagReducer'
import alert from './alertReducer'
import site from './siteReducer'

const rootReducer = combineReducers({
    session,
    cart,
    bag,
    alert,
    site,
    form: formReducer
});

export default rootReducer;
